import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SharedService } from '../../shared.service';

@Component({
  selector: 'app-refresh-btn',
  templateUrl: './refresh-btn.component.html',
  styleUrls: ['./refresh-btn.component.scss']
})
export class RefreshBtnComponent implements OnInit {

  @Input() fromComponent: string;

  @Input() sectionName: string;

  @Output() btnClickEvent = new EventEmitter();

  idString = '';

  constructor(private sharedService: SharedService) { }

  ngOnInit(): void {
    this.idString = this.sharedService.createIdString(this.fromComponent, this.sectionName, 'refreshBtn');
  }

  refreshClickEvent() {
    this.btnClickEvent.emit(true);
  }
}
